import React from "react";
import { ReportTree } from "./style.js";
import ReactGA from "react-ga";
import { Treebeard, decorators } from "react-treebeard";
import defaultTheme from "react-treebeard/lib/themes/default";
import grey from '@material-ui/core/colors/grey'
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import ArrowRightIcon from '@material-ui/icons/ChevronRightRounded';
import Icon from '@material-ui/core/Icon';
import BlockIcon from '../../../../icons/BlockIcon';
import reportIcon from '../../../../../assets/img/report-icon.svg';
import axios from "axios";
import _ from "lodash";
import { generateGuid } from "../../../../../modules/guid";
import IntegrationAutosuggestClass from "./IntegrationAutosuggestClass";
import TypographyParagraph from '../../../../../components/TypographyParagraph';
import Button from '../../../../../components/Button';
import PeriodSelect from './components/PeriodSelect/index.jsx';
import { withStyles, useTheme } from "@material-ui/core/styles";

ReactGA.initialize("UA-52754256-15");

function CustomChevron({ style }) {
  const theme = useTheme();

  return (
    <ArrowRightIcon 
      style={{
        color: theme.palette.primary.main,
        margin: '-1px 2px 0 -5px',
        fontSize: 26,
      }}
    />
  )
};

function CustomHeader({ node, style, prefix }) {
  const theme = useTheme();
  const hasReport = node.datasetId && !node.suppressed;
  let headerColor = '#2f6c92';
  if (node.active || node.toggled) headerColor = theme.palette.primary.main;
  if (node.active && !hasReport) headerColor = '#a5a5a5';

  return (
    <div
      style={{
        ...style.base,
        color: headerColor,
        fontFamily: 'Roboto',
        fontSize: 16,
      }}
    >
      {node.active ? <div id="scrollposition" style={{position:'absolute', top:'-10px'}}></div> : null}
      <div
        style={{
          ...style.title,
          display: 'flex',
          fontWeight: node.toggled || (node.active && hasReport) ? 'bold' : '',
        }}
      >
        {node.name}
      </div>
    </div>
  )
};

const customContainerStyles = theme => ({
  customContainer: {
    height: 38,
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.5, 1.5),
  },
  reportIcon: {
    marginLeft: 1,
  },
  blockIcon: {
    display: 'flex',
    alignItems: 'center',
    width: 14,
    margin: '0 8px 2px 1px',
  },
  suppressed: {
    margin: '0 0 23px 13px',
    display: 'flex',
    flexWrap: 'wrap',
  },
  nodeDescription: {
    fontStyle: 'italic',
    color: '#f77b0c',
    marginRight: 5,
  },
  link: {
    textDecoration: 'underline',
    color: '#005d82',
  }
});

class CustomContainerClass extends decorators.Container {
  render() {
    const { style, decorators, terminal, onClick, node, classes } = this.props;
    const hasReport = node.datasetId && !node.suppressed;
    let backgroundColor = '#f0f1f2';
    if (node.active) {
      backgroundColor = hasReport ? '#b9ccd8' : '#fef5ec';
    }
    let maxHeight = 38;
    if (node.active && !hasReport && (node.nodeDescription || node.link)) {
      maxHeight = 80;
    }
    const divStyle = {
      ...style.container[0],
      backgroundColor,
      borderRadius: 2,
      maxHeight,
      transition: 'max-height 0.3s',
      margin: '0 0 4px',
      overflow: 'hidden',
    }
    return (
      <div
        onClick={onClick}
        ref={ref => (this.clickableRef = ref)}
        style={divStyle}
      >
        <div style={!node.children ? {marginLeft: '23px'} : null } className={classes.customContainer}>
          {!terminal ? this.renderToggle() : null}
          {hasReport && (
            <Icon className={classes.reportIcon} >
              <img alt='report-icon' src={reportIcon} />
            </Icon>
          )}
          {!hasReport && (
            <BlockIcon stroke={node.active ? '#a5a5a5' : '#2f6c92'} className={classes.blockIcon} />
          )}
          <decorators.Header node={node} style={style.header} />
        </div>
        {!hasReport && (
          <div className={classes.suppressed}>
            {node.nodeDescription && <div className={classes.nodeDescription}>{node.nodeDescription}.</div>}
            {node.link && (
              <div>
                <a href={node.link} className={classes.link}>
                  Launch Debriefer
                </a>
              </div>
            )}
          </div>
        )}
        {/* {node.shareable &&
            <button
              style={{ marginLeft: "14px" }}
              onClick={e => {
                e.stopPropagation();
                node.handleOpen(node);
                // TODO: figure out how to get user object in here...
                // TODO: bring up another dialog that allows you to enter an email, then a check a box to make it their default report
                // TODO: create endpoint to create new share, leverage it here using the node.id
              }}
            >
              Share
            </button>
          )} */}
      </div>
    );
  }
}

const CustomContainer = withStyles(customContainerStyles)(CustomContainerClass)

const switchReportStyles = theme => ({
  dialogContainer: {
    padding: theme.spacing(1, 0),
  },
  title: {
    color: theme.palette.primary.light,
    fontWeight: 300,
    fontSize: 24,
    paddingBottom: theme.spacing(0.5),
  },
  contentText: {
    color: grey[400],
    fontSize: 16,
    marginBottom: theme.spacing(3.5),
    paddingTop: theme.spacing(1.5),
  },
  dialogActions: {
    padding: theme.spacing(0, 3, 2, 3),
  },
  dialogButton: {
    margin: theme.spacing(0, 0, 0, 1),
  },
});

class SwitchReport extends React.Component {
  constructor(props) {
    super(props);
    this.onToggle = this.onToggle.bind(this);
  }

  data = {
    name: "Survey Reports",
    toggled: true,
    children: [],
    shareable: false
  };

  state = {
    cursor: {},
    reportPeriod: this.props.currentReport.surveyPeriod,
  };

  loadNode(node) {
    const { user } = this.props;
    if (node.loading) {
      axios
        .get(`/api/summary-report-trees/${node.id}?u=${generateGuid()}`)
        .then(res => {
          const children = res.data.filter(d => d);
          for (let i = 0; i < children.length; i++) {
            const child = children[i];
            child.name = child.datasetName;
            child.link = child.datasetId
              ? `/summary-reports/${child.id}`
              : undefined;
            child.children = Array.isArray(child.nodes) && child.nodes.length > 0 ? [] : undefined;
            child.loading = Array.isArray(child.nodes) && child.nodes.length > 0;
          }
          node.loading = false;
          node.children = children;
          if (
            _.includes(user.roles, "SRH_ADMIN") ||
            _.includes(user.roles, "SYSTEM_ADMIN")
          ) {
            for (let i = 0; i < node.children.length; i++) {
              node.children[i].shareable = true;
              node.children[i].handleOpen = this.handleOpen;
            }
          }
          this.setState({ change: !this.state.change });
        });
    }
  }

  parseTreeNodes(nodes, selected) {
    let result = [];
    
    for(let node of nodes) {
      
      //skip null nodes
      if (!node) continue;

      //determine child nodes by either parse the node children or return an empty array if there are unloaded nodes
      const parsedNode = {
        ...node,
        children: Array.isArray(node.children) ? this.parseTreeNodes(node.children, selected) : Array.isArray(node.nodes) && node.nodes.length > 0 ? [] : null,
        toggled: !!node.toggled,
        handleOpen: this.handleOpen,
        onToggle: this.onToggle,
        name: node.datasetName,
        link: node.datasetId ? `/summary-reports/${node.id}` : undefined,
        active: node.id === selected,
      };
      result.push(parsedNode);
      if (parsedNode.active) this.setState({cursor: parsedNode});
    }
    return result;
  }

  componentDidMount() {
    const { summaryReportTree, currentReport } = this.props;
    const { reportPeriod } = this.state;
    const newReportsInPeriod = _.filter(summaryReportTree, report => report.surveyPeriod === reportPeriod);
    this.data.children = this.parseTreeNodes(newReportsInPeriod, currentReport.id);
  }

  handleEntered = () => {
    const scrollel = document.getElementById('scrollposition');
    if (!scrollel) return;

    const scrollcontainer = document.getElementsByClassName('MuiDialogContent-root')[0];
    if (!scrollcontainer) return;
    const containerheight = scrollcontainer.getBoundingClientRect().bottom - scrollcontainer.getBoundingClientRect().top;
    scrollcontainer.scrollTop = scrollel.getBoundingClientRect().top - 50 - (containerheight / 2);
  }

  handleEntering = () => {
    this.setState({ cursor: {} });
  };

  handleCancel = () => {
    this.props.onClose();
  };

  handleOk = () => {};


  resetActiveNode(nodes) {
    for(let n of nodes) {

      if (this.props.currentReport.id !== n.id) 
        n.active = false;

      if (Array.isArray(n.children)) {
        this.resetActiveNode(n.children);
      }
    }
  }

  onToggle(node, toggled) {
    if (this.state.cursor) {
      this.setState({
        ...this.state,
        cursor: {active: true}
      })
    }
    const isLoading = (Array.isArray(node.children) && node.children.length === 0 && Array.isArray(node.nodes) && node.nodes.length > 0)
    
    if (isLoading) {
      node.loading = true;
    }

    this.resetActiveNode(this.data.children);

    this.loadNode(node);
    node.active = true;
    if (node.children) {
      node.toggled = toggled;
    }
    this.setState({ cursor: node });
  }

  handleChangeReportPeriod = period => {
    const { summaryReportTree, currentReport } = this.props;
    const newReportsInPeriod = _.filter(summaryReportTree, report => report.surveyPeriod === period);
    this.data.children = this.parseTreeNodes(newReportsInPeriod, currentReport.id);
    this.setState({
      reportPeriod: period,
    });
  }

  render() {
    const { classes, summaryReportTree, currentReport, ...other } = this.props;
    const { reportPeriod } = this.state;
    const surveyPeriods = _.map(summaryReportTree, report => report.surveyPeriod);
    defaultTheme.tree.node.subtree.paddingLeft = '39px';

    return (
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        onEntering={this.handleEntering}
        onEntered={this.handleEntered}
        aria-labelledby="simple-dialog-title"
        maxWidth="md"
        fullWidth={true}
        classes={{ paper: classes.dialogContainer }}
        {...other}
      >
        {summaryReportTree.length > 1 && (
          <PeriodSelect 
            selectablePeriods={_.uniq(surveyPeriods)} 
            reportPeriod={reportPeriod}
            setReportPeriod={this.handleChangeReportPeriod}
          />
        )}
        <DialogTitle className={classes.title} disableTypography={true}>
          Switch Report
          <TypographyParagraph className={classes.contentText}>
            Search for a report or choose one from the list below
          </TypographyParagraph>
          <IntegrationAutosuggestClass data={this.data.children} reportPeriod={reportPeriod} />
        </DialogTitle>
        <DialogContent>
          <ReportTree>
            <Treebeard
              data={this.data}
              onToggle={this.onToggle}
              style={{ ...defaultTheme, marginTop: '25px' }}
              active={true}
              decorators={{
                ...decorators,
                Toggle: CustomChevron,
                Header: CustomHeader,
                Container: CustomContainer
              }}
            />
          </ReportTree>
        </DialogContent>
        <div
          style={{
            textAlign: "center",
            paddingTop: "14px",
            paddingBottom: "8px"
          }}
        >
        </div>
        <DialogActions classes={{ root: classes.dialogActions }}>
          <Button onClick={this.handleCancel} classes={{ root: classes.dialogButton }}>
            Cancel
          </Button>
          {this.state.cursor.link && (
            <a href={this.state.cursor.link}>
              <Button onClick={this.handleOk} classes={{ root: classes.dialogButton }} variant="contained">
                Switch report to {this.state.cursor.name}
              </Button>
            </a>
          )}
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(switchReportStyles)(SwitchReport);



// WEBPACK FOOTER //
// ./src/components/SRHHeaders/SummaryReportHeader/components/SwitchReport/index.jsx